// @flow
import React, { useContext } from 'react';
import { If } from '@presentational/If';

import { EstimateContext } from '../contexts/EstimateContext';
import { getIfCustomerViewIsEnabled } from '../common-utils/utils';
import { WarningMessageContainer } from '../components/presentational/messages/WarningMessageContainer';

export const ConnectTasksAlertContainer = () => {
  const estimateData = useContext(EstimateContext);
  const isCustomerViewEnabled = getIfCustomerViewIsEnabled(estimateData?.inputs);
  const isConnectorsAlertSentByBE =
    estimateData?.alert_aggregations?.connector_alert?.show_connector_alert ?? false;
  const shouldShowAlert = isConnectorsAlertSentByBE && !isCustomerViewEnabled;

  return (
    <If test={shouldShowAlert}>
      <WarningMessageContainer message="ALERT: High Connect task count, customer is eligible for add'l Connect-specific discounts. Do NOT quote list price on Connect for this account." />
    </If>
  );
};
